<template>
    <div class="biz-tool-bar" :class="{'fixed': isFixed}">
        <div class="biz-tool-bar-wrap">
            <div></div>
            <div class="group">
                <a href="https://line.me/R/ti/p/@271gwqam" target="_blank" rel="noopener noreferrer">
                    <div class="btn service">
                        專屬客服
                    </div>
                </a>
                <div class="btn QA" @click="$router.push({name: 'bizFaq'})">
                    常見問題
                </div>
                <biz-user-menu></biz-user-menu>
            </div>
        </div>
        
    </div>
</template>
<script>
import bizUserMenu from '@/components/bussiness/widges/menu/bizUserMenu.vue';

export default {
    data () {
        return {
            isFixed: false,
        }
    },
    mounted () { 
        this.updateList() 
    },
    watch: { 
        '$route' () { 
            this.updateList() 
        } 
    },
    methods: {
        updateList () { 
            if(this.$route.meta.isFixed){
                this.isFixed = true
            }else{
                this.isFixed = false
            }
        }
    },
    components: {
        bizUserMenu,
    }
}
</script>
<style lang="scss">
    .biz-tool-bar{
        position: relative;
        width: 100%;
        background: #fff;
        z-index: 7;
        .biz-tool-bar-wrap{
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 70px;
            right: -1px;
            width: calc(1180px - 40px);
            padding: 0 30px;
            // border-bottom: 1px solid #f0f0f0;
            .group{
                position: relative;
                display: flex;
                align-items: center;
                .btn{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 104px;
                    height: 42px;
                    border-radius: 4px;
                    margin-right: 12px;
                    cursor: pointer;
                }
                .service{
                    background-color: #fff9f1;
                    color: #eb7859;
                }
                .QA{
                    background-color: #f6f6f6;
                    color: #676362;
                }
            }
        }
        
    }   
    .biz-tool-bar.fixed{
        position: fixed;
        z-index: 7;
    } 
    @media screen and (max-width: 1280px) {
        .biz-tool-bar{
            width: 1200px;
            .biz-tool-bar-wrap{
                width: 100%;
                // right: -6px;
                >.group{
                    right: 60px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/menu/bizToolBar.vue